/**
 * Every `import.meta.env` read this app makes outside its entry point.
 *
 * They are collected here for one reason: Node's CommonJS runtime, which Jest
 * uses, cannot compile a file containing the `import.meta` token at all. It
 * throws "Cannot use 'import.meta' outside a module" before a single test runs,
 * and it does so for every module that transitively imports the offending one. A
 * read sitting in a hook therefore breaks any spec that renders a screen reaching
 * that hook, naming the hook rather than the read.
 *
 * With the reads here, `jest.config.js` maps this module to a stub and the rest of
 * the app stays testable. `productionEnv.ts` does the same for the shared library.
 *
 * Vite statically replaces these at build time, so runtime behaviour is unchanged.
 * `main.tsx` still reads `import.meta.env.DEV` directly, which is fine: it is the
 * entry point and no spec imports it.
 */

/** Whether this is a dev build. */
export const IS_DEV: boolean = import.meta.env.DEV;

/**
 * Base URL of the published incident.io status page, when a deployment sets one.
 *
 * Documented in `CLAUDE.md` as `VITE_STATUS_PAGE_URL`. Unset is normal: the
 * sidebar indicator falls back to a static state.
 */
export const STATUS_PAGE_URL: string | undefined = import.meta.env
  .VITE_STATUS_PAGE_URL;
